import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustBadges = () => {
  const badges = [
    { icon: 'Shield', label: 'SSL Secured' },
    { icon: 'Lock', label: 'Data Encrypted' },
    { icon: 'CheckCircle', label: 'Verified Platform' }
  ];

  return (
    <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 pt-6 border-t border-border">
      {badges?.map((badge, index) => (
        <div key={index} className="flex items-center gap-2">
          <Icon name={badge?.icon} size={16} color="var(--color-success)" />
          <span className="text-xs text-muted-foreground">{badge?.label}</span>
        </div>
      ))}
    </div>
  );
};

export default TrustBadges;